import { defineMessages } from 'react-intl'

export default defineMessages({
  increaseRateTitle: {
    id: 'containers.SupplierProfile.components.Rates.Chart.increaseRateTitle',
    defaultMessage: 'Increase {currencySymbol}/word',
  },
  decreaseRateTitle: {
    id: 'containers.SupplierProfile.components.Rates.Chart.decreaseRateTitle',
    defaultMessage: 'Decrease {currencySymbol}/word',
  },
  wordCount: {
    id: 'containers.SupplierProfile.components.Rates.Chart.wordCount',
    defaultMessage: 'Word count',
  },
  chartShowMore: {
    id: 'containers.SupplierProfile.components.Rates.Chart.showMore',
    defaultMessage: 'Show for {words}+ words',
  },
  chartHoverHint: {
    id: 'containers.SupplierProfile.components.Rates.Chart.hoverHint',
    defaultMessage: '{words} words pays {amount} {currency}',
  },
  chartHint: {
    id: 'containers.SupplierProfile.components.Rates.Chart.hint',
    defaultMessage: 'Hover chart for rate example',
  },
})
